<div class="sidenav" [ngClass]="{'hidden': isHidden}">
  <div class="container d-flex flex-column" *ngIf="menuList$| async as menuList">
    <div class="menu" *ngFor="let menu of menuList; let i = index" [ngClass]="{selected: menu.isSelected, disabled: menu.disabled, hidden: menu.hidden}" [ngStyle]="{'margin-top':  i === menuList.length - 1 ? 'auto' : ''}" >
      <div class="menu-item d-flex flex-column justify-content-center"
        (click)="onMenuClick(menu,menuList)" [ngClass]="{selected: menu.isSelected, disabled: menu.disabled}">
        <div class="icon-box d-flex flex-column align-items-center" [ngClass]="{disabled: menu.disabled}">
          <mc-icon *ngIf="menu.isSelected" icon="{{ menu.icon }}" size="24" color="#42B0D5"></mc-icon>
          <mc-icon *ngIf="!menu.isSelected" icon={{menu.icon}} size="24">
          </mc-icon>
        </div>
      </div>
      <div class="title d-flex flex-column align-items-center" [ngClass]="{disabled: menu.disabled}" *ngIf="menu.showLabel">{{menu.displayName}}</div>
    </div>
  </div>
</div>